<template>
    <main id="mainCtrl">
        <PassportDetailsDialog ref="passportDetailsDialog" @updated="updateTable" />

        <v-table id="passportDetailsTable"
                 request-uri="passportDetails/getList"
                 pagesize="50"
                 ref="table">
          <template v-slot:header>
            <v-tr>
              <v-th name="created_at" sort="created_at" width="100">
                Дата
              </v-th>
              <v-th name="fullname" minwidth="150">
                ФИО
              </v-th>
              <v-th name="doctu_url"  minwidth="150">
                URL
              </v-th>
              <v-th name="status" width="100">
                Подтверждён
              </v-th>
                <v-th name="unpublish_reason" minwidth="150">
                    Причина отклонения
                </v-th>
                <v-th name="verified_at" sort="verified_at" width="100">
                    Дата проверки
                </v-th>

            </v-tr>
            <v-tr>
              <v-th name="created_at" v-slot="{filter}" width="100">
                <date-piker v-model="filter.value"/>
              </v-th>
              <v-th name="fullname" :debounce="true" v-slot="{filter}" minwidth="150">
                <v-input v-model="filter.value"/>
              </v-th>
              <v-th name="doctu_url" v-slot="{filter}" minwidth="150">
                <v-input v-model="filter.value"/>
              </v-th>
              <v-th name="status" v-slot="{filter}" width="100">
                <v-select
                    v-model="filter.value"
                    :options="[
                        { value: '', text: '\u00a0' },
                        { value: 'NEW', text: 'Новый' },
                        { value: 'VERIFIED', text: 'Подтвержден' },
                        { value: 'UNVERIFIED', text: 'Отклонено' },
                    ]"
                />
              </v-th>
                <v-th name="unpublish_reason" :debounce="true" v-slot="{filter}" minwidth="150">
                    <v-input v-model="filter.value"/>
                </v-th>
                <v-th name="verified_at" v-slot="{filter}" width="100">
                    <date-piker v-model="filter.value"/>
                </v-th>

            </v-tr>
          </template>
          <template v-slot:row="{ item, index }">
            <v-tr class="hover pointer"
                  :id="'dc-tr-' + item.id"
                  @click="(row, event) => handleRowClick(event, item, row)"
            >
              <v-td name="created_at"  highlight="*">
                {{ item.created_at | formatDate }}
              </v-td>
              <v-td name="fullname">
                {{ item.fullname }}
              </v-td>
              <v-td name="doctu_url">
                {{ item.doctu_url }}
              </v-td>
              <v-td name="status" align="center">
                <span v-if="item.status === 'UNVERIFIED'">Отклонено</span>
                <span v-if="item.status === 'NEW'" class="label bg-red">Новый</span>
                <span v-if="item.status === 'VERIFIED'">Подтвержден</span>
              </v-td>
                <v-td name="unpublish_reason">
                    {{ item.verification_unpublish_reason }}
                </v-td>
                <v-td name="verified_at"  highlight="*">
                    {{ item.verified_at | formatDate }}
                </v-td>



            </v-tr>
          </template>



        </v-table>


    </main>
</template>
<script>
import PassportDetailsDialog from "./PassportDetailsDialog";

export default {
  components: {PassportDetailsDialog},
  methods: {
    handleRowClick(event, item, row) {
      row.startLoadingAnimation();

      this.$refs.passportDetailsDialog.show(item.id)
          .then(() => row.stopLoadingAnimation())
          .catch(() => row.stopLoadingAnimation());
    },

    updateTable() {
      this.$refs.table.update();
      this.$bus.fire('updateMenu');
    }
  },
}
</script>
